import "./about.css";
import { useEffect, useState } from "react";
import apiRequest from "../../apiCall";
import ReactHtmlParser from "react-html-parser";
import config from "../../Admin/Config.json";
import { setLoading } from "../../Redux/action";
import { useDispatch } from "react-redux";

export default function AboutPage() {
  const [aboutData, setAboutData] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      dispatch(setLoading(true));
      const res = await apiRequest("GET", "about-us", null, false, false);
      setAboutData(res);
      dispatch(setLoading(false));
      
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(setLoading(false));
    }
  };

  return aboutData && aboutData.ShowInWebSite === 1 ? (
    <div className="aboutUs">
      <div className="aboutcreamdemo-image">
        {aboutData.featureImage && (
          <img
            src={config.awsMediaPath + aboutData.featureImage}
            style={{ width: "100%" }}
            alt="Feature Image"
          />
        )}
      </div>
  
      <div className="aboutus-text-container">
        <center className="tp">
          <p>{ReactHtmlParser(aboutData.content)}</p>
        </center>
      </div>
      <div className="about-use-step">
        <div className="about-use-step-bg">
          {aboutData.featureImage1 && (
            <img src={config.awsMediaPath + aboutData.featureImage1} alt="Feature Image 1" />
          )}
        </div>
        <div className="about-use-step-text">
          <p>{ReactHtmlParser(aboutData.sectionAHtmlContent)}</p>
        </div>
  
        <div className="about-use-step-item">
          {aboutData.cardData && aboutData.cardData.map((card, index) => (
            <div className={`about-use-step-${index + 1}`} key={index}>
              {card.cardImage && (
                <img src={config.awsMediaPath + card.cardImage} alt={`Card Image ${index}`} />
              )}
              <p>{card.cardName}</p>
            </div>
          ))}
        </div>
      </div>
  
      <div className="aboutus-youtubevideo">
        {aboutData.sectionCVideo && (
          <iframe
            src={aboutData.sectionCVideo}
            frameBorder="0"
            allowFullScreen
            title="YouTube Video"
          ></iframe>
        )}
      </div>
    </div>
  ) : (
    <></>
  );
}  